import React from "react";
import "../assets/css/style.css";
import "../style/HomeScreen.css";
import AppLink from "./AppLink/AppLink";
import AppLinkAndroid from "./AppLink/AppLinkAndroid";
import AppLinkIOS from "./AppLink/AppLinkIOS";

const HeroUI = ({ displaySet }) => {
  return (
    <section id="hero">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 pt-5 pt-lg-0 order-2 order-lg-1 d-flex align-items-center">
            <div style={{ marginTop: "-100px" }}>
              <h1>
                <span id="wordChanger">
                  സർക്കാർ സെക്യൂരിറ്റികളിൽ നിക്ഷേപിക്കുക
                </span>
              </h1>
              <h2>സുരക്ഷിതം... ലളിതം... നേരിട്ട് !!!!!!</h2>
              <div className="text-center text-lg-left">
                <a
                  href="https://rbiretaildirect.in/#/rdg-account-registration"
                  target="_blank"
                  className="btn-get-started"
                >
                  RBI റീട്ടെയിൽ ഡയറക്ട് അക്കൗണ്ട് തുറക്കുക
                </a>

                <i
                  title="എങ്ങനെ രജിസ്റ്റർ ചെയ്യണം?"
                  className="ri-information-line icon-info"
                  onClick={() => displaySet(true)}
                ></i>
              </div>
              <h3>
                ഇതിനകം രജിസ്റ്റർ ചെയ്തിട്ടുണ്ടോ? ഇതിൽ ലോഗിൻ ചെയ്യുക:{" "}
                <a
                  href="https://rbiretaildirect.in"
                  target="_blank"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="പ്രൈമറി ലേല ബിഡ്ഡിങ്ങിനായി ലോഗിൻ ചെയ്യുക "
                >
                  <i className="ri-user-shared-line"></i> RBI റീട്ടെയിൽ ഡയറക്ട്
                  അക്കൗണ്ട്
                </a>
                /
                <a
                  href="https://retail.ndsom.com"
                  target="_blank"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="RBI റീട്ടെയിൽ ഡയറക്ട് അക്കൗണ്ടിൽ നിന്നുള്ള ആക്‌സസ് സജീവമാക്കിയ ശേഷം സെക്കൻഡറി മാർക്കറ്റ് ട്രേഡിംഗിനായി ലോഗിൻ ചെയ്യുക "
                >
                  <i className="ri-line-chart-line"></i> എൻ.ഡി.എസ്-ഒ.എം.
                  സെക്കൻഡറി മാർക്കറ്റ്
                </a>
                <AppLink />
              </h3>
            </div>
          </div>
          <div className="col-lg-4 order-1 order-lg-2 hero-img">
            <img
              src="https://rbiretaildirect.org.in/common/img/svg/rbi.svg"
              className="img-flui animated rbiSeal"
              alt="RBI Seal"
            />
          </div>
        </div>
      </div>
      <AppLinkAndroid />
      <AppLinkIOS />
    </section>
  );
};
export default HeroUI;
